<template>
  <div class="baseContent-warp">
    <Card v-loading="loading">
      <span slot="title">随访记录详情</span>
      <el-button slot="btn" class="fr"
        @click="$router.push('/patientfollowup/followuplist?status=' + followUpInfo.status)">返回列表</el-button>
      <div slot="content" class="followup-wrap">
        <!-- 患者信息 -->
        <div class="patientInfo">
          <div class="title">
            患者信息
            <el-button class="btn" icon="el-icon-view"
              @click="$router.push('/patient/patientdetails?patientId=' + patientForm.patientId)">患者详情</el-button>
          </div>
          <div class="content p10">
            <div class="line">
              <div>{{ patientForm.patientName }}</div>
              <div>性别：{{ patientForm.sex == '0' ? '男' : '女' }}</div>
              <div>年龄：{{ patientForm.year }}岁<span
                  v-show="patientForm.year < 10 && patientForm.month > 0">{{ patientForm.month }}月</span></div>
              <div>电话：{{ patientForm.phone }}</div>
              <div>是否挂号：{{ followUpInfo.isRegister == 1 ? '是' : '否' }}</div>
            </div>
            <div class="line mt10">
              <div>运营标签：</div>
            </div>
            <div class="line mt10">
              <div>病症标签：
                <el-tag class="mr10" effect="dark" v-for="(tag, j) in historyInfo.hospPathologyLabels" :key="j">
                  {{ tag.pathologyLabelName }}({{ tag.postName }})
                </el-tag>
              </div>
            </div>
          </div>
        </div>
        <!-- 随访信息 -->
        <div class="followUpInfo mt10">
          <div class="title">
            随访信息
            <div class="btn" v-if="followUpInfo.status == '0'">
              <el-button icon="el-icon-plus" type="primary" @click="followUpAdd('1')">自动随访</el-button>
              <el-button icon="el-icon-plus" type="primary" @click="followUpAdd('0')">人工随访</el-button>
            </div>
            <el-button class="btn" icon="el-icon-view" @click="showDetails" v-else>随访详情</el-button>
          </div>
          <div class="content p10">
            <div class="line">
              <div>随访状态：{{ followUpInfo.statusStr }}</div>
              <div>随访分类：{{ followUpInfo.targerStr || '-' }}</div>
              <div>随访类型：{{ followUpInfo.typeStr || '-' }}</div>
              <div>随访人员：{{ followUpInfo.createBy }}</div>
              <div>随访途径：{{ followUpInfo.channel || '-' }}</div>
              <div>随访描述：{{ followUpInfo.hintMessage || '-' }}</div>
              <div>复诊时间：{{ followUpInfo.visitTime || '-' }}</div>
              <div>满意程度：{{ followUpInfo.level || '-' }}</div>
              <div>疗效反馈：{{ followUpInfo.effectFeedback || '-' }}</div>
              <div>计划随访时间：{{ followUpInfo.examTime || '-' }}</div>
              <div>随访完成时间：{{ followUpInfo.completeTime || '-' }}</div>
            </div>
            <div class="line mt10 imgAddr" v-if="type == '0'">
              <span>随访凭证：</span><img :src="followUpInfo.imgAddr" width="150">
            </div>
          </div>
        </div>
        <!-- 病历信息 -->
        <div class="historyInfo mt10" v-if="JSON.stringify(historyInfo).length != 2">
          <div class="title">病历信息</div>
          <div class="content p10">
            <div class="line">
              <div class="mr20">开方医生：{{ followUpInfo.doctorName }}</div>
              <div class="line"> 医生诊断：{{ historyInfo.diagnosis || '对症治疗' }} </div>
            </div>
            <div class="recipewrap">
              <div class="recipe" v-for="(item, i) in historyInfo.recipeDrugs" :key="item.recipeDrugId">
                <div>中药处方{{ i + 1 }}：</div>
                <div class="mt10">
                  药材：
                  <span class="mr10" v-for="drug in item.recipeDrugItem" :key="drug.drugId">
                    {{ drug.drugName }} {{ drug.number }} {{ drug.unit }}
                    <i v-show="drug.handling != null">({{ drug.handling }})</i>
                  </span>
                </div>
                <div>
                  {{ item.doseNumber }} 付，
                  {{ item.drugMethod }} {{ item.dose }} {{ item.frequency }}
                  <span v-if="item.takingDosage">，每次 {{ item.takingDosage }} ml</span>
                </div>
                <div>
                  医嘱：<span class="mr10" v-for="(advice, i) in item.recipeDrugAdvice" :key="i">{{ i + 1 }}.
                    {{ advice.value }}</span>
                </div>
              </div>
              <div class="recipe" v-for="item in historyInfo.recipeCombos" :key="item.recipeComboId">
                <div>{{ item.comboName }}</div>
                <div class="mt10">
                  药材：
                  <span class="mr10" v-for="drug in item.recipeComboItems" :key="drug.artNo">
                    {{ drug.comboItemName }} {{ drug.number }} {{ drug.unit }}
                  </span>
                </div>
                <div>{{ item.doseNumber }} 付</div>
                <div>
                  医嘱：<span class="mr10" v-for="(advice, i) in item.recipeDrugAdvice" :key="i">{{ i + 1 }}.
                    {{ advice.value }}</span>
                </div>
              </div>
              <div class="recipe" v-for="(item, i) in historyInfo.recipePhysio" :key="item.recipePhysioId">
                <div>理疗处方{{ i + 1 }}：</div>
                <div class="mt10">
                  项目：<span class="mr10" v-for="(physio, i) in item.recipePhysioItem" :key="i">{{ physio.physioName }}
                    {{ physio.number }} 次</span>
                </div>
                <div>
                  医嘱：<span class="mr10" v-for="(advice, i) in item.recipePhysioAdvice" :key="i">{{ i + 1 }}.
                    {{ advice.value }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 新建随访或随访详情 -->
        <el-dialog class="followUpEdit" :title="dialogTitle" :visible.sync="dialogVisible" width="600px"
          :before-close="done => $handleClose(done, 'editForm')" :close-on-click-modal="false">
          <el-form :model="editForm" :rules="editFormRules" ref="editForm" inline label-width="80px"
            :disabled="followUpInfo.status != '0'" :style="{ maxHeight: formHeight + 'px' }">
            <el-form-item label="随访人员" prop="examRealityName">
              <el-input v-model="editForm.examRealityName" disabled />
            </el-form-item>
            <el-form-item label="随访分类" prop="targer">
              <el-radio-group v-model="editForm.targer" @change="targerChange">
                <el-radio label="0">复诊随访</el-radio>
                <el-radio label="1">日常随访</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="是否挂号" prop="isRegister">
              <el-radio-group v-model="editForm.isRegister">
                <el-radio label="0">否</el-radio>
                <el-radio label="1">是</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="问卷模板" prop="examTemplateId" v-if="followUpInfo.status == '0' && editForm.targer == '0'">
              <el-select v-model="editForm.examTemplateId" placeholder="请选择随访模板" @change="setQuestion">
                <el-option v-for="item in templateOptions" :key="item.examTemplateId" :label="item.examTemplateName"
                  :value="item.examTemplateId" />
              </el-select>
            </el-form-item>
            <el-form-item label="回访内容" v-if="editForm.targer == '1'" prop="hintMessage">
              <el-select class="msg-wrap" allow-create clearable filterable default-first-option
                v-model="editForm.hintMessage" placeholder="请选择日常随访回访内容">
                <el-option v-for="item in hintList" :key="item.examHintMessageTemplate" :value="item.content"
                  :label="item.content" />
              </el-select>
            </el-form-item>
            <el-form-item label="其他信息" prop="describe">
              <el-input v-model="editForm.describe" placeholder="请输入其他用户反馈信息" />
            </el-form-item>
            <el-form-item label="随访问卷" class="questionList mr0" prop="questionsList"
              v-if="(editForm.examTemplateId || editForm.questionsList != undefined) && editForm.targer == '0'">
              <div v-for="(item, i) in editForm.questionsList" :key="item.examRecordQuestionsId">
                <el-form-item v-if="item.questionsType == 2" :label="'题' + (i + 1) + '：' + item.questionsTitle"
                  :prop="'questionsList.' + i + '.testAnswer'"
                  :rules="[{ required: true, message: '简答答案不能为空！', trigger: 'blur' }]">
                  <el-input v-model="item.testAnswer" placeholder="请输入简答题答案" />
                </el-form-item>
                <el-form-item v-else-if="item.questionsType == 0" :label="'题' + (i + 1) + '：' + item.questionsTitle"
                  :prop="'questionsList.' + i + '.selectAnswerId'"
                  :rules="[{ required: true, message: '选项答案不能为空！', trigger: 'blur' }]">
                  <el-radio-group v-model="item.selectAnswerId" @change="val => setRadioAnswer(val, item)">
                    <el-radio v-for="answer in item.templateAnswers" :key="answer.examRecordAnswerId"
                      :label="answer.examRecordAnswerId">
                      <div>{{ answer.answerContent }}</div>
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item v-else :label="'题' + (i + 1) + '：' + item.questionsTitle"
                  :prop="'questionsList.' + i + '.selectAnswerIds'"
                  :rules="[{ required: true, message: '选项答案不能为空！', trigger: 'blur' }]">
                  <el-checkbox-group v-model="item.selectAnswerIds" @change="val => setCheckboxAnswer(val, item)">
                    <el-checkbox v-for="answer in item.templateAnswers" :key="answer.examRecordAnswerId"
                      :label="answer.examRecordAnswerId">
                      <div>{{ answer.answerContent }}</div>
                    </el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </div>
            </el-form-item>
            <div v-if="type == '0'">
              <el-form-item label="随访途径" prop="channel">
                <el-radio-group v-model="editForm.channel">
                  <el-radio label="电话" />
                  <el-radio label="微信" />
                  <el-radio label="当面" />
                </el-radio-group>
              </el-form-item>
              <el-form-item label="随访凭证" prop="imgAddr">
                <div v-if="editForm.imgAddr" class="img">
                  <img :src="editForm.imgAddr" />
                  <div @click="editImg" v-show="followUpInfo.status == '0'" class="del">x</div>
                </div>
                <el-upload v-else :action="uploadUrl" list-type="picture-card" :on-success="handleImgSuccess"
                  name="uploadFile" :data="{ storagePath: 'picture' }"><i class="el-icon-plus"></i>
                </el-upload>
              </el-form-item>
            </div>
            <el-form-item label="随访时间" prop="examTime">
              <el-date-picker v-model="editForm.examTime" value-format="yyyy-MM-dd HH:mm" type="datetime"
                placeholder="请选择随访时间" />
            </el-form-item>
            <el-form-item label="复诊时间" prop="visitTime">
              <el-date-picker v-model="editForm.visitTime" value-format="yyyy-MM-dd HH:mm" type="datetime"
                placeholder="请选择复诊时间" />
            </el-form-item>
          </el-form>
          <!-- 操作按钮 -->
          <span slot="footer" class="dialog-footer">
            <el-button type="success" @click="editSave(editForm)" v-if="followUpInfo.status == '0'">保存修改</el-button>
            <el-button @click="$cancel('dialogVisible', 'editForm')">取 消</el-button>
          </span>
        </el-dialog>
      </div>
    </Card>
  </div>
</template>

<script lang="js">
import { followUpInfo, followUpAuto, followUpArtificial, followUpQuestion } from "@/api/followup"; // 获取随访请求
import { historyInfo, historyRecipes } from "@/api/history"; // 病历请求
import { templateList, questionList, hintBankList } from "@/api/followup-questionnaire"; // 获取问卷请求
import { patientInfo } from "@/api/patient"; // 获取患者请求
export default {
  name: "FollowUpDetails",
  data() {
    return {
      loading: true, // 加载动画
      followUpInfo: {}, // 随访详情
      historyInfo: {}, // 病历详情
      patientForm: {}, // 患者信息
      examRecordId: this.$route.query.examRecordId, // 当前随访id
      dialogTitle: null, // 模态框标题
      dialogVisible: false, // 随访模态框状态
      imgVisible: false, // 图片放大框
      editForm: {}, // 随访对象
      editFormRules: {
        channel: [{ required: true, message: "随访渠道不能为空！", trigger: "blur" }],
        examTime: [{ required: true, message: "随访时间不能为空！", trigger: "blur" }],
        imgAddr: [{ required: true, message: "随访凭证不能为空！" }],
        targer: [{ required: true, message: "随访分类不能为空！", trigger: "blur" }],
        examRealityName: [{ required: true, message: "随访人员不能为空！", trigger: "blur" }],
        examTemplateId: [{ required: true, message: "随访问卷模板不能为空！", trigger: "blur" }],
        hintMessage: [{ required: true, message: "日常自动随访问题描述不能为空！", trigger: "blur" }],
        isRegister: [{ required: true, message: "是否挂号不能为空！", trigger: "blur" }],
      }, // 验证规则
      uploadUrl: this.$baseUrl + '/file/upload', // 图片上传接口地址
      templateOptions: [], // 随访模板列表
      type: null, // 随访类型
      formHeight: 500, // 表单最高度
      hintList: [], // 日常随访模板
    }
  },
  created() {
    this.getFollowUpInfo(); // 请求随访详情
    this.getTemplateList(); // 请求问卷列表
    this.getHintList(); // 获取日常随访列表
    this.formHeight = Math.floor(document.documentElement.clientHeight * 0.86 - 180); // 弹框表单最高高度
  },
  methods: {
    // 获取随访详情
    async getFollowUpInfo() {
      let { code, data } = await followUpInfo(this.examRecordId);
      if (code == 200) {
        switch (data.status) {
          case '-1': data.statusStr = '不随访'; break;
          case '0': data.statusStr = '待执行'; break;
          case '1': data.statusStr = '推送完成'; break;
          case '2': data.statusStr = '完成随访'; break;
        }
        switch (data.targer) {
          case '0': data.targerStr = '复诊随访'; break;
          case '1': data.targerStr = '日常随访'; break;
        }
        switch (data.type) {
          case '0': data.typeStr = '人工随访'; break;
          case '1': data.typeStr = '自动随访'; break;
        }
        this.followUpInfo = data;
        this.type = data.typeStr;
        if (data.orderId) this.getHistoryInfo(data.orderId);
        else this.getPatientInfo(data.patientId);
      }
      this.loading = false;
    },
    // 请求日常随访列表
    async getHintList() {
      let { rows, code, total } = await hintBankList();
      if (code == 200) this.hintList = rows;
    },
    // 请求随访问卷模板列表
    async getTemplateList() {
      let { rows, code } = await templateList();
      if (code == 200) this.templateOptions = rows;
    },
    // 请求患者信息
    async getPatientInfo(patientId) {
      let { data, code } = await patientInfo(patientId);
      if (code == 200) {
        this.$computeAge(data.birthday, data);
        this.patientForm = data;
      }
    },
    // 请求病历详情
    async getHistoryInfo(orderId) {
      let { code, data } = await historyInfo(orderId);
      if (code == 200) {
        data.recipeDrugs = [], data.recipePhysio = [];
        this.historyInfo = data;
        this.$computeAge(data.hospPatientInfo.birthday, data.hospPatientInfo);
        this.patientForm = data.hospPatientInfo;
        this.getRecipeList(orderId);
      }
    },
    // 请求处方列表
    async getRecipeList(orderId) {
      let { code, data } = await historyRecipes(orderId);
      if (code == 200) {
        this.historyInfo.recipeDrugs = data.recipeDrugs;
        this.historyInfo.recipeCombos = data.recipeCombos;
        this.historyInfo.recipePhysio = data.recipePhysios;
      }
    },
    // 随访分类改变
    targerChange(val) {
      if (val == 0) this.editForm.hintMessage = null;
      else this.editForm.examTemplateId = null
    },
    // 设置随访问题
    async setQuestion(val) {
      if (this.type == '0') {
        let { code, rows } = await questionList({ examTemplateId: val });
        if (code == 200) {
          rows.forEach(item => {
            item.selectAnswerId = null;
            item.selectAnswerIds = [];
            item.templateAnswers.forEach(kid => { kid.examRecordAnswerId = kid.examTemplateAnswerId });
          })
          this.editForm.questionsList = rows;
        }
      }
    },
    // 设置单选答案
    setRadioAnswer(val, question) {
      question.templateAnswers.forEach(item => { item.answerSelect = 0 });
      question.templateAnswers.forEach(item => {
        if (item.examRecordAnswerId == val) {
          item.answerSelect = 1;
          question.testAnswer = item.answerContent;
        }
      });
    },
    // 设置复选框答案
    setCheckboxAnswer(val, question) {
      question.testAnswer = "";
      question.templateAnswers.forEach(item => { item.answerSelect = 0; });
      question.templateAnswers.forEach(item => {
        val.forEach(kid => {
          if (item.examRecordAnswerId == kid) {
            item.answerSelect = 1;
            question.testAnswer += item.answerContent + '，';
          }
        })
      });
      let len = question.testAnswer.length;
      question.testAnswer = question.testAnswer.substring(0, len - 1);
    },
    // 新建随访
    followUpAdd(type) {
      this.type = type;
      this.dialogTitle = "新建随访";
      this.dialogVisible = true;
      this.editForm = {
        channel: null, examRealityName: this.$session.get('user').nickName, hintMessage: null, examTime: null,
        imgAddr: null, isRegister: null, questionsList: [], targer: null, visitTime: null, examTemplateId: null,
        examRecordId: this.examRecordId, examRecordIds: [this.examRecordId],
      }
    },
    // 保存随访新建
    editSave(obj) {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          if (this.type == '0') {
            followUpArtificial(obj).then(res => {
              if (res.code == 200) {
                this.$message.success('创建人工随访成功！');
                this.loading = true;
                this.dialogVisible = false;
                this.getFollowUpInfo();
                this.$refs['editForm'].resetFields();
              }
            });
          } else {
            followUpAuto(obj).then(res => {
              if (res.code == 200) {
                this.$message.success('创建自动随访成功！');
                this.loading = true;
                this.dialogVisible = false;
                this.getFollowUpInfo();
                this.$refs['editForm'].resetFields();
              }
            });
          }
        } else return false;
      })
    },
    // 查看详情
    async showDetails() {
      this.dialogTitle = "随访详情";
      this.dialogVisible = true;
      if (this.followUpInfo.channel != null) {
        this.followUpInfo.type = '0';
        this.editForm = this.followUpInfo;
        let { code, rows } = await followUpQuestion({ examRecordId: this.followUpInfo.examRecordId });
        if (code == 200) {
          rows.forEach(item => {
            if (item.questionsType == '0') item.selectAnswerId = Number(item.selectAnswerId);
            else if (item.questionsType == '1') item.selectAnswerIds = JSON.parse(JSON.stringify([item.selectAnswerId]).replace(/\"/g, ""));
          })
          this.editForm.questionsList = rows;
          this.$forceUpdate();
        }
      }
    },
    // 图片上传成功
    handleImgSuccess(res) {
      let { code, msg } = res;
      if (code === 200) this.editForm.imgAddr = msg;
    },
    // 清除图片地址，显示上传图片
    editImg() {
      this.editForm.imgAddr = null;
    },
  }
}
</script>

<style lang="less" scoped>
/deep/.el-card__body {
  overflow-y: scroll;
}

.followup-wrap {
  .followUpEdit {

    .el-input,
    .el-select {
      width: 480px !important;

      /deep/.el-input {
        width: 480px;

        input {
          width: 480px;
        }
      }
    }
  }

  /* 基础样式 */
  &>div:not(.followUpEdit) {
    border: 1px solid #ccc;
    line-height: 24px;
    font-size: 14px;
  }

  .title {
    position: relative;

    .btn {
      position: absolute;
      right: 6px;
      top: 6px;
    }
  }

  .line {
    display: flex;
    flex-wrap: wrap;

    div {
      margin-right: 20px;
    }
  }

  /* 随访信息样式 */
  .followUpInfo {
    .line {
      div {
        min-width: 220px;
      }
    }

    .imgAddr {
      display: flex;
      align-items: center;

      img {
        border: 1px solid #e6e6e6;
      }
    }
  }

  /* 处方样式 */
  .recipewrap {
    display: flex;
    flex-wrap: wrap;

    .recipe {
      width: 480px;
      margin-right: 10px;
      border: 1px solid #ccc;
      padding: 20px 10px;
      margin-top: 10px;
    }
  }
}</style>